import { RefDataType, WireAnalyticsEvent } from 'scenes/common/types';
import { ReferenceData } from 'scenes/landlord/api/referenceData/types';
import {
  LandlordFunnelState,
  WireLandlordAnalytics,
} from 'scenes/landlord/types';

import { toWireFormData } from './formData';
import { toWireProperty } from './property';
import { toWirePage } from './page';

export const marshalViewLoadedEvent = (
  state: LandlordFunnelState,
  referenceData: ReferenceData
): WireLandlordAnalytics => {
  const { buildingTypes } = referenceData;
  return {
    event: WireAnalyticsEvent.ViewLoaded,
    page: toWirePage(state),
    formData: toWireFormData(state),
    property: toWireProperty(state, buildingTypes),
  };
};

export const marshalCallUsEvent = (
  state: LandlordFunnelState
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.CallUs,
  page: toWirePage(state),
  formData: toWireFormData(state),
});

export const marshalSaveQuoteEvent = (
  state: LandlordFunnelState
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.SaveQuote,
  page: toWirePage(state),
  formData: toWireFormData(state),
});

export const marshalEmailQuoteEvent = (
  state: LandlordFunnelState
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.EmailQuote,
  page: toWirePage(state),
  formData: toWireFormData(state),
});

export const marshalResumeQuoteEvent = (
  state: LandlordFunnelState
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.ResumeQuote,
  page: toWirePage(state),
  formData: toWireFormData(state),
});

export const marshalRetrieveQuoteCompleteEvent = (
  state: LandlordFunnelState
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.RetrieveQuoteComplete,
  page: toWirePage(state),
  formData: toWireFormData(state),
});

export const marshalQuoteReferred = (
  state: LandlordFunnelState,
  quoteNumber: string,
  buildingTypes: RefDataType[]
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.QuoteReferred,
  page: toWirePage(state),
  formData: toWireFormData(state, quoteNumber),
  property: toWireProperty(state, buildingTypes),
});

export const marshalQuoteDeclined = (
  state: LandlordFunnelState,
  quoteNumber: string,
  buildingTypes: RefDataType[]
): WireLandlordAnalytics => ({
  event: WireAnalyticsEvent.QuoteDeclined,
  page: toWirePage(state),
  formData: toWireFormData(state, quoteNumber),
  property: toWireProperty(state, buildingTypes),
});
